<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { sellerService } from "../../../../../services/saleservice/seller.service";
import List from "../../../../../components/list";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "User List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    List 
  },
  data() {
    return {
      sellerDataList: {},
      fetchingStats: false,
      title: "Sellers List",

    };
  },
  mounted() {

    this.loadingData();
  },

  methods: {
    loadingData: function(param = '') {
      this.fetchingStats = false;

      param = `?clause={"clause":{"and":{"sellers.type_id":{"value":1}}}}`;
      sellerService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.sellerDataList = response;
        });
    },

    deleted: function(id) {
      sellerService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-security-user-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-security-user-add'}" :title="$t('setting.security.user.text')" />
    <List v-bind:dataList="sellerDataList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[`code: ${$t('seller.code')}`, `name: ${$t('seller.name')}`, 
            `phone_no_1: ${$t('seller.phone-no')}`, `email: ${$t('seller.email')}`, `address: ${$t('seller.address')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-security-user-edit'}"

          v-bind:filter="{
            search: ['sellers.code', 'sellers.name', 'sellers.name_en', 'sellers.phone_no_1', 'sellers.phone_no_2'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>